﻿<script lang="ts" setup>
    import { reactive, onMounted, watch, inject } from 'vue';
    import { setupInitValues } from './Contact';
    import { type Contact } from './Contact.access';
    import Form from '@cwd/shared/Components/Form/Form.vue';
    import { FormProps, isEmpty } from '@cwd/shared/components/Form/Form';
    import { AccountAccess } from '@cwd/Account/Account.access';
    import { injectorAccessInjectionKey } from '@cwd/lib/provider-keys';

    const injectorAccess = inject(injectorAccessInjectionKey)!;
    const accountAccess: AccountAccess = injectorAccess.injector.get(AccountAccess);

    const props = defineProps<{
        contact: Contact;
        submitting: boolean;
    }>();

    const state = reactive<{
        form: FormProps;
    }>({
        form: {
            data: {},
        },
    });

    onMounted(async () => {
        setupFields([1, 2, 3, 4, 5, 6, 7, 8, 9, 10], 'Custom', $Resources.CustomFieldsTextFieldsHeading);
        setupFields([1, 2], 'CustomLong', $Resources.CustomFieldsLongTextFieldsHeading);
        setupFields([1, 2], 'CustomDate', $Resources.CustomFieldsDateFieldsHeading);
        setupFields([1, 2, 3, 4, 5, 6], 'CustomNumeric', $Resources.CustomFieldsNumericFieldsHeading);

        setupInitValues(props.contact, state.form);

        watch(
            () => props.contact,
            (newVal) => {
                if (!newVal) return;

                setupInitValues(newVal, state.form);
            }
        );
    });

    const setupFields = (numberArr: number[], name: string, groupName: string) => {
        numberArr.forEach((number: number) => {
            let customField = accountAccess.state.currentAccount!.CustomField as any;
            let key = name === 'Custom' ? 'CustomField' : name;
            let fieldName = customField[key + number];

            state.form.data[name + number] = {
                modelValue: undefined,
                group: groupName,
                input: {
                    label: fieldName,
                    placeholder: fieldName,
                    type: name === 'CustomDate' ? 'date' : name === 'CustomNumeric' ? 'number' : 'text',
                },
            };
        });
    };
</script>

<script lang="ts"></script>

<template>
    <h2 class="h4">{{ $Resources.ContactModalProfileCustomInformationHeading }}</h2>

    <Form
        v-if="!isEmpty(state.form.data)"
        class="fieldset-grid"
        :data="state.form.data"
        :submitting="props.submitting"
        :saveOnChange="true"
        @update:isValid="(key, newVal) => (state.form!.data[key].isValid = newVal)"
        @update:modelValue="(key, newVal) => (state.form.data[key].modelValue = newVal)"
        @onSubmitSingleInput="(key: string, newVal: any) => $emit('onSubmitSingleInput', key, newVal)"></Form>
</template>

<style></style>
